import { isInApp } from './AppUtilities'

import { useContext } from 'react'

import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'

import useFeatureFlag from 'Hooks/useFeatureFlag/useFeatureFlag'

const useAppInstall = () => {
  const { promptAppInstall, appInstallPrompt } = useContext(TrackingContext)

  const pwaEnabledFlag = useFeatureFlag('Frontend_PWA')

  return {
    displayAppInstallPrompt: promptAppInstall,
    canPromptForAppInstall: pwaEnabledFlag && !!appInstallPrompt,
    pwaEnabledAtAll: pwaEnabledFlag,
  }
}

export default useAppInstall
